function Hr() {
  return (
    <hr
      className="hr my-5"
      style={{
        opacity: '0.7',
        background: '#4e5d6c',
        height: '5px',
        width: '50vw',
        left: '112px',
        top: '98px',
        borderRadius: '0px',
        // minWidth: '800px',
      }}
    />
  );
}

export default Hr;
